export default __webpack_public_path__ + "static/media/4254.21596f84.png";